import type { FC } from 'react'
import * as Yup from 'yup'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { TextFieldInput, TextFieldInputProps } from './TextFieldInput.js'

export const VatNumberInput: FC<TextFieldInputProps> = ({ name, ...props }) => {
  const { t } = useTranslation()
  return (
    <TextFieldInput
      {...props}
      name={name}
      type="text"
      label={t('inputs.vatNumberInput.vatNumberLabel')}
      data-test="vat-number-input"
    />
  )
}

export const createVatNumberValidationSchema = (
  t: TFunction
): Yup.StringSchema<string | undefined, Yup.AnyObject, '', 'd'> =>
  Yup.string()
    .default('')
    .trim()
    .max(100, t('inputs.vatNumberInput.vatNumberIsLongMessage', { max: 100 }))
    .matches(/^[a-zA-Z0-9\s\-.]*$/, t('inputs.vatNumberInput.vatNumberInvalidFormatMessage'))
